(function() {
    'use strict';
    angular
        .module('quantixApp')
        .controller('AifbenchmarkController', AifbenchmarkController);

    AifbenchmarkController.$inject = ['$scope', 'AIFBenchmarkService', '$http', '$window', '$filter'];

    function AifbenchmarkController($scope, AIFBenchmarkService, $http, $window, $filter) {

        $scope.message = '';
        $scope.isError = false;
        var userGrid = ''
        $scope.fileUpload = null;

        $scope.uploadExcelTemplate = function(file) {
            $scope.closeAlert();
            var fd = new FormData();
            fd.append('file', file); 
            AIFBenchmarkService.uploadExcelTemplate(fd).then(function(response) {
                        $scope.loadHistoricalData()
                        $scope.fileUpload = null;
                        $scope.message = response.data;
                        if($scope.message['Success']) {
                            $scope.isError = false;
                        } else {
                            $scope.isError = true;
                        }
                }, function(error) {
                        $scope.loadHistoricalData()
                        $scope.isError = true;
                        $scope.message = error.data;
                        $scope.fileUpload = null;
                }
            );  
        }

    $scope.closeAlert = function() {
        $scope.message = '';
    }

    $scope.downloadTemplate = function(templateType) {
        $http({
                url : 'api/aifbenchmark/downloadaiftemplate',
                method : 'POST',
                data: templateType,
                responseType : 'arraybuffer'
            }).success(
                    function(response) {
                        var isIE = false || !!document.documentMode;
                        $scope.response = response;
                        var templateName = 'AIF'+templateType+'Template.xlsx';
                        var blob = new Blob(
                                [ response ],
                                {
                                    type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                });
                        if (isIE) {
                            window.navigator
                                    .msSaveOrOpenBlob(
                                            blob,
                                            'AIF'+templateType+'Template.xlsx');
                        } else {
                            var anchor = angular
                                    .element('<a/>');
                            var blob = new Blob(
                                    [ response ],
                                    {
                                        type : 'application/vnd.ms-excel'
                                    })
                            var objectUrl = (window.URL || window.webkitURL)
                                    .createObjectURL(blob);
                            anchor.css({
                                display : 'none'
                            });
                            angular.element(
                                    document.body)
                                    .append(anchor); 
                            anchor
                                    .attr({
                                        href : objectUrl,
                                        target : '_self',

                                        download : templateName
                                    })[0].click();

                            anchor.remove();
                        }
                    })
    }

    
    $scope.loadHistoricalData = function() {
        AIFBenchmarkService.getHistoricalData().then(function(response) {
            $scope.userGrid = {

                dataProvider : response.data,
                delegate : $scope
    
            };
            $scope.historicalData = response.data;
        }, function error() {});
    }

    $scope.userGridCompletion = function(event) {
        userGrid = event.target;
        userGrid.validateNow();
    }

    $window.downloadFile = function(item) {
        $http({
            url : 'api/aifbenchmark/downloadaifexcelfromfiler',
            method : 'POST',
            data: item.parentNode.component.data,
            responseType : 'arraybuffer'
        }).success(
                function(response) {
                    var isIE = false || !!document.documentMode;
                    $scope.response = response;
                    var templateName = item.parentNode.component.data.filename;
                    var blob = new Blob(
                            [ response ],
                            {
                                type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                            });
                    if (isIE) {
                        window.navigator
                                .msSaveOrOpenBlob(
                                        blob,
                                        item.parentNode.component.data.filename);
                    } else {
                        var anchor = angular
                                .element('<a/>');
                        var blob = new Blob(
                                [ response ],
                                {
                                    type : 'application/vnd.ms-excel'
                                })
                        var objectUrl = (window.URL || window.webkitURL)
                                .createObjectURL(blob);
                        anchor.css({
                            display : 'none'
                        });
                        angular.element(
                                document.body)
                                .append(anchor); 
                        anchor
                                .attr({
                                    href : objectUrl,
                                    target : '_self',

                                    download : templateName
                                })[0].click();

                        anchor.remove();
                    }
                })
    }

    $scope.downloadFileTemplate = function(rowData, column) {
        var html = '<span class="load" onClick= "downloadFile(this)"><i class="fa fa-download hover upload-color" title="Load" ></i>';
        return html;
    }
    
    $scope.getDate = function(rowData, column) {
        return $filter('date')(rowData.uploadedAt,'dd-MMM-yyyy H:mm:ss');
    }

    $scope.getUploadStatus = function(rowData, column) {
        if(rowData.uploadStatus == 'Y') {
            return '<span class="load  upload-color">Successful</span>';
        } else {
            return '<span class="load upload-fail">Unsuccessful</span>';
        }
    }

    $scope.downloadFaq =  function(rowData, column) {
        $http({
            url : 'api/aifbenchmark/downloadfaq',
            method : 'POST',
            responseType : 'arraybuffer'
        }).success(
                function(response) {
                    var isIE = false || !!document.documentMode;
                    $scope.response = response;
                    var templateName = 'AIF Benchmarking-FAQs.pdf';
                    var blob = new Blob(
                            [ response ],
                            {
                                type : 'application/pdf'
                            });
                    if (isIE) {
                        window.navigator
                                .msSaveOrOpenBlob(
                                        blob,
                                        'AIF Benchmarking-FAQs.pdf');
                    } else {
                        var anchor = angular
                                .element('<a/>');
                        var blob = new Blob(
                                [ response ],
                                {
                                    type : 'application/pdf'
                                })
                        var objectUrl = (window.URL || window.webkitURL)
                                .createObjectURL(blob);
                        anchor.css({
                            display : 'none'
                        });
                        angular.element(
                                document.body)
                                .append(anchor); 
                        anchor
                                .attr({
                                    href : objectUrl,
                                    target : '_self',

                                    download : templateName
                                })[0].click();

                        anchor.remove();
                    }
                })
    }
    }
})();